import React, { useEffect, useState } from 'react';
import { FlatList, VStack } from 'native-base';
import { Section } from '~/shared/Theme';
import { Caption } from '~/shared/Typography';
import { StoreModal } from './components/StoreModal';
import { CartItemCard } from './components/CartItemCard';
import {
    Item,
    Order,
    useDutchieStore,
    useGetCustomers,
    useSpringBigStore,
    useTheme,
} from '@springbig/shared';
import { useAppNavigate } from '..';
import { TabSelector } from '~/pages/shop/components/TabSelector';
import { SpIcon } from '~/shared/Icon';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { Button } from '~/shared/Theme';

export const ShoppingCartPage = () => {

    const {
        primary,
    } = useTheme();

    const { member } = useSpringBigStore();
    const [showStore, setShowStore] = useState(false);

    const {
        fullfillmentOption,
        retailer,
        checkout,
        orders,
        setOrders,
        isBusy,
    } = useDutchieStore();

    const { mutate: getCustomers } = useGetCustomers();
    const { params, navigate } = useAppNavigate();


    useEffect(() => {

        if (member?.consumer.email_validated && member?.consumer.email) {
            getCustomers({
                'retailerId': retailer?.id,
                'filters': { 'email': member?.consumer.email.toLocaleLowerCase() }
            }, {
                onSuccess(data) {

                    const firstFive = data.customers.splice(0, 4);
                    const firstFiveOrders: Array<Order> = [];
                    firstFive.forEach((customer) => {

                        customer.orders?.forEach((order) => {

                            firstFiveOrders.push(order);
                        });
                    });
                    firstFiveOrders.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));
                    if (firstFiveOrders) {
                        setOrders(firstFiveOrders);
                    }
                },
            });
        }
    }, [member]);

    const tabs = [
        {
            name: 'current cart',
            isSelected: true,
        },
        {
            name: 'past orders',
            action: () => navigate(`w/${params.wallet_id}/shop/orders/`),
        },
    ];

    const onGoToCheckout = (): void => {

        if (checkout?.redirectUrl) {
            const url = new URL(checkout?.redirectUrl);
            if (member) {
                if (member.first_name) {
                    url.searchParams.append(
                        'firstName',
                        member?.first_name,
                    );
                }

                if (member.last_name) {
                    url.searchParams.append(
                        'lastName',
                        member?.last_name,
                    );
                }

                if (member.phone_number) {
                    url.searchParams.append('phone', member.phone_number);
                }

                if (member.birthday) {
                    const birthdaySplit = member.birthday.split('-');
                    const birthdateFormated =
                        birthdaySplit[1] +
                        birthdaySplit[2] +
                        birthdaySplit[0];
                    url.searchParams.append(
                        'birthdate',
                        birthdateFormated,
                    );
                }

                if (
                    member.consumer.email &&
                    member.consumer.email_validated
                ) {
                    url.searchParams.append(
                        'email',
                        member.consumer.email.toLocaleLowerCase(),
                    );
                }
            }


            const redirectUrl = `${window.location.origin}/w/${params.wallet_id}/shop/`;
            url.searchParams.append(
                'r',
                redirectUrl,
            );
            window.open(url);
        }
    };

    return (
        <Section h={'100%'}>
            <VStack h={'100%'} justifyContent={'space-between'}>
                { checkout?.items.length > 0 ?
                    <VStack alignItems={'center'} flex={1}>
                        <VStack space={4} p={4}>
                            <TabSelector tabs={tabs} />
                            <Button
                                modifier={'small'}
                                text={`${fullfillmentOption?.label} in ${retailer?.name}`}
                                disabled={isBusy}
                                onPress={() => {

                                    setShowStore(true);
                                }}
                            />
                        </VStack>

                        <FlatList
                            w={'100%'}
                            h={'60%'}
                            px={4}
                            horizontal={false}
                            data={checkout?.items}
                            renderItem={({ item, index } : { item: Item, index: number}) =>

                                <CartItemCard item={item} key={index} />
                            }
                        />
                    </VStack>
                    :
                    <VStack
                        flex={1}
                        alignItems={'center'}
                        justifyContent={'space-between'}
                        space={4}
                        pt={4}
                        px={4}
                    >
                        <TabSelector tabs={tabs} />
                        <VStack space={4}>
                            <SpIcon color={primary} icon={faShoppingCart} size={100} />
                            <Caption text={'shop.cart_empty'} />
                        </VStack>
                        <VStack w={'full'}>
                            { orders && orders.length > 0 &&
                                <Button
                                    text={'shop.see_past_orders'}
                                    disabled={isBusy}
                                    onPress={() => navigate(`w/${params.wallet_id}/shop/orders/`)}
                                />
                            }
                        </VStack>
                    </VStack>
                }
                <VStack space={4} p={4}>
                    { checkout?.items && checkout?.items.length > 0 &&
                        <Button
                            text={'shop.go_to_checkout'}
                            disabled={isBusy}
                            onPress={onGoToCheckout}
                        />
                    }
                    <Button
                        text={'shop.back_to_store'}
                        variant={'neutral'}
                        disabled={isBusy}
                        onPress={() => navigate(`w/${params.wallet_id}/shop`)}
                    />
                </VStack>
            </VStack>
            { showStore &&
                <StoreModal
                    showStore={showStore}
                    setShowStore={() => {

                        setShowStore(!showStore);
                    }}
                />
            }
        </Section>
    );
};
